export const LOST_FOUND_STATUS = {
  LOST: 'lost',
  FOUND: 'found',
  COLLECTED: 'collected',
};

export const LOST_FOUND_TABS = [
  { id: 'all', label: 'All' },
  { id: LOST_FOUND_STATUS.LOST, label: 'Lost' },
  { id: LOST_FOUND_STATUS.FOUND, label: 'Found' },
  { id: LOST_FOUND_STATUS.COLLECTED, label: 'Collected' },
];

/** Maps UI tab id to community lost-found list ?status= query value */
export const tabToListFilter = tabId => {
  if (tabId === LOST_FOUND_STATUS.LOST) return 'lost';
  if (tabId === LOST_FOUND_STATUS.FOUND) return 'found';
  if (tabId === LOST_FOUND_STATUS.COLLECTED) return 'collected';
  return undefined;
};

export const formatLostFoundDate = dateStr => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const getStatusLabel = status => {
  if (!status) return '—';
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const getLocationFieldLabels = status => {
  if (status === LOST_FOUND_STATUS.LOST) {
    return { locationLabel: 'Lost at', handoffLabel: 'Submit at' };
  }
  return { locationLabel: 'Found at', handoffLabel: 'Collect at' };
};

export const buildLostFoundShareText = item => {
  if (!item) return '';
  const { locationLabel, handoffLabel } = getLocationFieldLabels(item.status);
  const lines = [
    'Lost & Found Item',
    `Item: ${item.item_name || '—'}`,
    `Status: ${getStatusLabel(item.status)}`,
    item.location ? `${locationLabel}: ${item.location}` : null,
    item.submit_collect_at ? `${handoffLabel}: ${item.submit_collect_at}` : null,
    `Date: ${formatLostFoundDate(item.date)}`,
    item.description ? `Description: ${item.description}` : null,
  ].filter(Boolean);
  return lines.join('\n');
};

export const normalizeItemStatus = status => {
  const s = String(status ?? '').trim().toLowerCase();
  if (s === LOST_FOUND_STATUS.FOUND) return LOST_FOUND_STATUS.FOUND;
  if (s === LOST_FOUND_STATUS.COLLECTED) return LOST_FOUND_STATUS.COLLECTED;
  if (s === LOST_FOUND_STATUS.LOST) return LOST_FOUND_STATUS.LOST;
  return s || LOST_FOUND_STATUS.LOST;
};

export const filterItemsByTab = (items, tabId) => {
  if (tabId === 'all') return items;
  return items.filter(item => normalizeItemStatus(item.status) === tabId);
};

export const filterItemsBySearch = (items, searchTerm) => {
  const q = String(searchTerm ?? '').trim().toLowerCase();
  if (!q) return items;
  return items.filter(
    item =>
      item.item_name?.toLowerCase().includes(q) ||
      item.location?.toLowerCase().includes(q) ||
      item.status?.toLowerCase().includes(q) ||
      item.description?.toLowerCase().includes(q)
  );
};
